import React from 'react'
import { PropTypes } from 'prop-types'
import Clipboard from 'react-clipboard.js'
import UIkit from 'uikit'
import settings from 'settings'


const propTypes = {
  token: PropTypes.string.isRequired,
  totalHackers: PropTypes.number.isRequired,
}

class TeamsUsersInvite extends React.Component {
  constructor(props) {
    super(props)

    this.onCopySuccess = this.onCopySuccess.bind(this)
    this.getInviteLink = this.getInviteLink.bind(this)
    this.handleInviteClick = this.handleInviteClick.bind(this)
  }

  onCopySuccess() {
    UIkit.notification({
      message: 'Copied to clipboard!',
      status: 'primary',
      pos: 'bottom-center',
      timeout: 1200,
    })
  }

  getInviteLink(token) {
    return `${settings.urls.app}/invite/${token}`
  }

  handleInviteClick(e) {
    e.target.select()
  }

  render() {
    const { totalHackers, token } = this.props
    const inviteLink = this.getInviteLink(token)
    return (
      <div className="uk-card uk-card-default uk-card-body" style={{ maxWidth: 750 }}>
        <div className="uk-margin">
          You have <span className="uk-text-large uk-text-bold">{totalHackers}</span> {totalHackers === 1 ? ' user' : ' users'} in your organization.
        </div>
        <div className="uk-margin">
          <div>
            Share this link to add users to your account for email/password onboarding:
          </div>
          {(token) && (
            <div className="uk-inline" style={{ width: 400 }}>
              <Clipboard
                component="span"
                data-clipboard-text={this.getInviteLink(token)}
                onSuccess={this.onCopySuccess}
              >
                <button
                  className="uk-form-icon uk-form-icon-flip"
                  data-uk-icon="copy"
                  type="button"
                />
              </Clipboard>
              <input
                type="text"
                className="uk-input"
                value={inviteLink}
                onClick={this.handleInviteClick}
                style={{
                  color: '#1e87f0',
                  paddingRight: '35px',
                }}
                readOnly
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

TeamsUsersInvite.propTypes = propTypes

export default TeamsUsersInvite
